import React from "react";
import { Modal, Row, Col } from "react-bootstrap";
import PrimaryButton from "../Buttons/PrimaryButton";
import SecondaryButton from "../Buttons/SecondaryButton";
import "./styles/ConfirmYesNo.css";

const ConfirmYesNoModal = ({
  isOpen,
  toggleModal,
  message,
  continueAction,
  cancelText = "No",
  confirmText = "Yes",
  isLoading = false
}) => {
  return (
    <Modal
      centered={true}
      show={isOpen}
      onHide={toggleModal}
      className={`confirm-yes-no-modal ${
        localStorage.getItem("isDark") === "true" ? "dark" : "light"
      }`}
    >
      <Modal.Header><span>Confirmation</span></Modal.Header>
      <Modal.Body>
        <div className="message">
          <h6 className="m-0">{message}</h6>
        </div>
      </Modal.Body>
      <Modal.Footer
        style={{
          display: "block",
        }}
      >
        <Row
          className="mb-1"
          style={{
            padding: 0,
            margin: 0,
            float: "right",
          }}
        >
          <Col xs={12}>
            <SecondaryButton
              title={cancelText}
              style={{
                marginLeft: 10,
                minWidth: "100px",
              }}
              onClick={() => toggleModal()}
              disabled={isLoading}
            />

            <PrimaryButton
              style={{
                marginLeft: 10,
                minWidth: "100px",
              }}
              onClick={() => continueAction()}
              title={confirmText}
              disabled={isLoading}
            />
          </Col>
        </Row>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmYesNoModal;
